function desktopNotification (title, option, target_url) {
  const notification = new Notification(title, option)

  notification.onclick = (e) => {
    window.open(`${process.env.VUE_APP_HOST_URL}${target_url}`, '_blank')
  }
}

export default desktopNotification
